import React from 'react'
import { blogPosts } from '../lib/FakeData'
import { BlogCard } from '../components/BlogCard'
import Breadcrumb from '../components/Breadcrumb'

const Blog = () => {
  const breadcrumbItems = [
    { label: "Trang chủ", href: "/" },
    { label: "Tin tức", href: "/blogs" },
  
  ];
  return (
    <>  
     <Breadcrumb items={breadcrumbItems} />
      <div className="w-full  flex justify-center items-center mt-8 p-4 xl:p-0">
        <div className="w-[--page-width] ">

          <div className='grid grid-cols-2 md:grid-cols-3 gap-4'>
            {blogPosts?.map((value, index) => {
              return <BlogCard key={index} item={value} />
            })}
          </div>
        </div>
      </div>
    </>
  )
}
export default Blog
